import { computedAsync } from '@vueuse/core';

export function useUserDigest() {
    const auth = useAuth();

    const digest = computedAsync<string | null | undefined>(async () => {
        if (!auth.value) return null;

        // Prepare input for hashing
        const SALT = 'm€d!ce';
        const input = `${auth.value.userId}${SALT}`;

        // Create digest
        const encoder = new TextEncoder();
        const data = encoder.encode(input);
        const digestBuffer = await window.crypto.subtle.digest('SHA-256', data);

        // Convert digest buffer to hex string
        const digestHex = Array.from(new Uint8Array(digestBuffer))
            .map((b) => b.toString(16).padStart(2, '0'))
            .join('');

        return digestHex;
    }, undefined);

    return { digest };
}
